import { z } from "zod";

export const driversHistoryGetPayloadSchema = z.object({
  companyUuid: z.uuid().optional(),
  departmentUuid: z.uuid().optional(),
});

export type DriversHistoryGetPayload = z.infer<
  typeof driversHistoryGetPayloadSchema
>;
